<h3 mat-dialog-title *ngIf="!isMobile()"><strong> Selecciona la aseguradora de tu preferencia </strong>
</h3>
<h4 class="align-center" mat-dialog-title *ngIf="isMobile()"><strong> Selecciona la aseguradora de tu preferencia
  </strong>
</h4>
<mat-dialog-content class="mat-typography">

  <div *ngIf="insurances.length !== 0">

    <div class="container-table" *ngIf="screenSize > 992">
      <table class="table-custom">
        <caption> Comparativa de seguros </caption>
        <thead>
          <tr>
            <th class="cell-radio" scope="col"> </th>
            <th scope="col"> Aseguradora </th>
            <ng-container *ngFor="let period of periods">
              <th class="text-center" scope="col"> Precio de seguro a {{ period }} meses </th>
            </ng-container>
            <!-- DEPRECATED 
            <th class="text-center" scope="col" *ngIf="data.isAfin"> Precio de seguro a 12 meses </th>
            <th class="text-center" scope="col"> Precio de seguro a 24 meses </th>
            <th class="text-center" scope="col"> Precio de seguro a 36 meses </th>
            <th class="text-center" scope="col"> Precio de seguro a 48 meses </th>
            <th class="text-center" scope="col" *ngIf="data.isAfin"> Precio de seguro a 60 meses </th> 
            -->
          </tr>
        </thead>
        <tbody>
          <tr class="cell-radio" [ngClass]="resultCompare(aseguradora[0].better!)"
            *ngFor="let aseguradora of insurances; let i = index">
            <td>
              <mat-radio-button [value]="aseguradora" (click)="onChange( (aseguradora[0].insurance || '' ) )"
                [checked]=" isCheck( (aseguradora[0].insurance || '' ) ) "> 
              </mat-radio-button>
            </td>
            <td> {{ (aseguradora[0]?.insurance ) }} </td>
            <ng-container *ngFor="let insurance of aseguradora">
              <td class="text-center"> {{ insurance.cost | currency }} </td>
            </ng-container>
            
            <!-- DEPRECATED
            <td class="text-center"> {{ aseguradora[0].cost | currency }} </td>
            <td class="text-center"> {{ aseguradora[1].cost | currency }} </td>
            <td class="text-center"> {{ aseguradora[2].cost | currency }} </td>
            <td class="text-center" *ngIf="data.isAfin"> {{ aseguradora[3].cost | currency }} </td>
            <td class="text-center" *ngIf="data.isAfin"> {{ aseguradora[4].cost | currency }} </td> 
            -->
          </tr>
        </tbody>
      </table>
    </div>


    <swiper [config]="config" *ngIf="screenSize <= 992">
      <ng-template swiperSlide *ngFor="let aseguradora of insurances; let i = index">

        <div class="card-custom" [ngClass]="resultCompare( aseguradora[0].better!)">

          <div>
            <strong> Aseguradora </strong>
            <p> {{ (aseguradora[0].insurance ) }} </p>
          </div>
          <ng-container *ngIf="data.isAfin;else notAfin">
            <div>
              <strong> Precio de seguro a 12 meses </strong>
              <p> {{ aseguradora[0].cost | currency }} </p>
            </div>

            <div>
              <strong> Precio de seguro a 24 meses </strong>
              <p> {{ aseguradora[1].cost | currency }} </p>
            </div>

            <div>
              <strong> Precio de seguro a 36 meses </strong>
              <p> {{ aseguradora[2].cost | currency }} </p>
            </div>

            <div>
              <strong> Precio de seguro a 48 meses </strong>
              <p>{{ aseguradora[3].cost | currency }} </p>
            </div>

            <div>
              <strong> Precio de seguro a 60 meses </strong>
              <p>{{ aseguradora[4].cost | currency }} </p>
            </div>
          </ng-container>
          <ng-template #notAfin>
            <div>
              <strong> Precio de seguro a 24 meses </strong>
              <p> {{ aseguradora[0].cost | currency }} </p>
            </div>

            <div>
              <strong> Precio de seguro a 36 meses </strong>
              <p> {{ aseguradora[1].cost | currency }} </p>
            </div>

            <div>
              <strong> Precio de seguro a 48 meses </strong>
              <p>{{ aseguradora[2].cost | currency }} </p>
            </div>
          </ng-template>

          <div class="text-center">
            <mat-radio-button [value]="aseguradora" (click)="onChange( (aseguradora[0].insurance || '' ) )"
              [checked]=" isCheck( (aseguradora[0].insurance || '' ) ) ">
            </mat-radio-button>
          </div>

        </div>

      </ng-template>
    </swiper>
  </div>

  <div class="row" *ngIf=" insurances.length === 0 ">
    <div class="col">
      <mat-dialog-content>
        Te mostraremos las opciones de aseguradoras que encontramos para ti...
      </mat-dialog-content>
    </div>

  </div>

</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="!isMobile() && insurances.length !== 0" style="gap: 30px;">
  <div class="flex-items mt-4">
    <label>
      <div class="square"> </div>
      <p> <strong> La mejor opción </strong> </p>
    </label>
  </div>

  <div class="row mt-lg-2">
    <div class="col p-0">

      <div class="container-buttons" *ngIf="ready">
        <button class="btn btn-cancel mt-3 mt-lg-0 " mat-button mat-dialog-close (click)="cancel()">
          Cancelar
        </button>
        <button class="btn btn-cambiar mt-3 mt-lg-0 " mat-raised-button (click)="closeWithValue()">
          Cambiar
        </button>
      </div>

    </div>
  </div>
</mat-dialog-actions>
<mat-dialog-actions align="center" *ngIf="isMobile() && insurances.length !== 0"
  [ngClass]="{'actions-mobile': isMobile()}">
  <label>
    <div class="square"> </div>
    <p> <strong> La mejor opción </strong> </p>
  </label>
  <button class="btn-cancel" mat-button mat-dialog-close>Cancelar</button>
  <button class="btn-cambiar" mat-button mat-raised-button (click)="closeWithValue()">Cambiar</button>
</mat-dialog-actions>
<mat-dialog-actions align="center" *ngIf="insurances.length === 0">
  <button class="btn-ok btn-cambiar" mat-button mat-dialog-close cdkFocusInitial> OK </button>
</mat-dialog-actions>